// src/components/MapModal.js
import React from "react";
import { Modal, Button } from "react-bootstrap";
import MapContainer from "./Map";

const MapModal = ({ show, onHide, location }) => {
  return (
    <Modal id="mapModel" show={show} size="lg" centered>
      <Modal.Header>
        <Modal.Title>Map View</Modal.Title>
        <Button variant="" className="close" onClick={onHide}>
          <span>&times;</span>
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "400px", width: "100%" }}>
          <MapContainer lat={location.lat} lng={location.lng} name={location.name} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ marginTop: "20px" }} onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MapModal;
